import React from 'react';
import { Check } from 'lucide-react';
interface OptionCardProps {
  label: string;
  text: string;
  selected: boolean;
  onSelect: () => void;
  variant?: 'choice' | 'scale';
}
export function OptionCard({
  label,
  text,
  selected,
  onSelect,
  variant = 'choice'
}: OptionCardProps) {
  return <button type="button" onClick={onSelect} aria-pressed={selected} className={`group flex w-full items-center gap-4 rounded-2xl border px-5 py-4 text-left transition-[background-color,border-color,box-shadow,transform] duration-200 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-dark sm:px-6 ${selected ? 'border-gold-dark bg-champagne shadow-soft' : 'border-gold/25 bg-ivory hover:border-gold/60 hover:bg-cream'}`} data-id="element-247" data-mp="n82gglk4b56o">
      <span className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full border text-[13px] font-semibold transition-colors duration-200 ${selected ? 'border-gold-dark bg-gold-dark text-white' : 'border-gold/40 bg-transparent text-gold-dark'} ${variant === 'scale' ? 'font-serif text-base' : ''}`} aria-hidden="true" data-id="element-248" data-mp="330t5gs86x66z">
        {selected ? <Check className="h-4 w-4" strokeWidth={2.5} data-id="element-249" data-mp="1426z0cybguzx" /> : label}
      </span>
      <span className={`text-[16px] leading-snug sm:text-[17px] ${selected ? 'text-ink' : 'text-ink-soft'}`} data-id="element-250" data-mp="104so8guzmf5t">
        {text}
      </span>
    </button>;
}